let months = [{
  value: 1,
  label: "1月"
},
{
  value: 2,
  label: "2月"
},
{
  value: 3,
  label: "3月"
},
{
  value: 4,
  label: "4月"
},
{
  value: 5,
  label: "5月"
},
{
  value: 6,
  label: "6月"
},
{
  value: 7,
  label: "7月"
},
{
  value: 8,
  label: "8月"
},
{
  value: 9,
  label: "9月"
},
{
  value: 10,
  label: "10月"
},
{
  value: 11,
  label: "11月"
},
{
  value: 12,
  label: "12月"
}
]

let seasons = [{
  value: 1,
  label: "第一季度",
},
{
  value: 2,
  label: "第二季度",
},
{
  value: 3,
  label: "第三季度",
},
{
  value: 4,
  label: "第四季度",
},
{
  value: 5,
  label: "全年",
},
]

let normItems = [{
  value: 10000,
  label: "共性指标"
},
{
  value: 20000,
  label: "个性指标"
},
{
  value: 30000,
  label: "加减分"
},
{
  value: 40000,
  label: "关键指标"
},
{
  value: 50000,
  label: "服务对象测评"
},
]

let roleItems = [{
  value: 100,
  label: "系统管理员"
},
{
  value: 101,
  label: "组织部汇总"
},
{
  value: 102,
  label: "局级管理"
},
{
  value: 103,
  label: "局长级"
},
{
  value: 106,
  label: "副局长级"
},
{
  value: 104,
  label: "局党组"
},
{
  value: 107,
  label: "科长级"
},
{
  value: 105,
  label: "考核领导小组"
},
{
  value: 108,
  label: "科员级"
},
{
  value: 109,
  label: "外部打分账号"
},
{
  value: 110,
  label: "牵头科室"
},
]

let normItemsAll = [{
  value: 10000,
  label: "共性指标",
  children: [{
    value: 10010,
    label: "政治标准",
    children: [{
      value: 10011,
      label: "政治忠诚"
    },
    {
      value: 10012,
      label: "政治定力"
    },
    {
      value: 10013,
      label: "政治能力"
    },
    ]
  },
  {
    value: 10020,
    label: "政治要求",
    children: [{
      value: 10021,
      label: "思想建设"
    },
    {
      value: 10022,
      label: "组织纪律"
    },
    {
      value: 10023,
      label: "道德品质"
    },
    {
      value: 10024,
      label: "廉洁自律"
    },
    ]
  },
  {
    value: 10030,
    label: "工作作风",
    children: [{
      value: 10031,
      label: "工作态度"
    },
    {
      value: 10032,
      label: "工作纪律"
    },
    ]
  },
  {
    value: 20000,
    label: "个性指标"
  },
  {
    value: 30000,
    label: "关键指标"
  },
  {
    value: 40000,
    label: "加减分",
    children: [{
      value: 40010,
      label: "加分"
    },
    {
      value: 40020,
      label: "减分"
    }
    ]
  },
  ]
},]



let departmentList = [{
  value: 10000,
  label: "长沙市住房和城乡建设局",
  children: [{
    value: 10001,
    label: "党委办公室",
  },
  {
    value: 10002,
    label: "人事科",
  },
  {
    value: 10003,
    label: "政策法规科",
  },
  {
    value: 10010,
    label: "城市建设科",
  },
  ]
}];

let regionList = [{
  regionId: 100,
  regionName: "赤峰地区",
  children: [
    {
      regionId: 24000,
      regionName: "赤峰市直",
      // children: [{
      //   regionId: 430102,
      //   regionName: "芙蓉区",
      // },
      // {
      //   regionId: 430104,
      //   regionName: "岳麓区",
      // },
      // {
      //   regionId: 430105,
      //   regionName: "开福区",
      // },
      // {
      //   regionId: 430111,
      //   regionName: "雨花区",
      // },
      // {
      //   regionId: 430112,
      //   regionName: "望城区",
      // },
      // {
      //   regionId: 430121,
      //   regionName: "长沙县",
      // },
      // {
      //   regionId: 430181,
      //   regionName: "浏阳市",
      // },
      // {
      //   regionId: 430182,
      //   regionName: "宁乡市",
      // }]
    },]
}]

let tableColumns = [{
  label: "序号",
  prop: "task_id",
  sortable: 1
},
{
  label: "任务分类",
  prop: "taskCategory"
},
{
  label: "责任人",
  prop: "respPerson"
},
{
  label: "工作内容",
  prop: "detail"
},
{
  label: "评价标准",
  prop: "evaCriterion"
},
{
  label: "分值",
  prop: "score"
},
{
  label: "任务类型",
  prop: ""
},
{
  label: "要求完成时限",
  prop: ""
},
{
  label: "是否完成",
  prop: ""
},
{
  label: "完成时间",
  prop: "endDate"
},
{
  label: "完成时效",
  prop: ""
},
{
  label: "完成比例",
  prop: ""
},
{
  label: "完成情况",
  prop: ""
},
]

let tableColumns2 = [{
  label: "序号",
  prop: "task_id",
  sortable: 1
},
{
  label: "业务类型",
  prop: "taskCategory"
},
{
  label: "年度",
  prop: "year"
},
{
  label: "季度",
  prop: "season"
},
{
  label: "月份",
  prop: "month"
},
{
  label: "填报时间",
  prop: "date"
},
{
  label: "报告名称",
  prop: "title"
},
{
  label: "负责人",
  prop: "name"
},
{
  label: "审批状态",
  prop: "state"
},
{
  label: "审批意见",
  prop: "advice"
},
]

let normTypesV2 = [
  {
    value: 1,
    label: "共性指标",
  },
  {
    value: 2,
    label: "个性指标",
  },
  {
    value: 3,
    label: "关键指标",
  },
  {
    value: 4,
    label: "加减分",
  },
  {
    value: 5,
    label: "民主测评",
  },
  {
    value: 6,
    label: "服务对象测评",
  },
  {
    value: 7,
    label: "党委打分",
  },
  {
    value: 8,
    label: "考勤",
  },
]

let normTypesV1 = [
  {
    value: 1,
    label: "共性指标",
  },
  {
    value: 100,
    label: "个性指标",
  },
  {
    value: 200,
    label: "关键指标",
  },
  {
    value: 4000,
    label: "加减分",
  },
  {
    value: 5000,
    label: "民主测评",
  },
  {
    value: 6000,
    label: "服务对象测评",
  },
  {
    value: 7000,
    label: "党委打分",
  },
]


const SPECIAL_SCORE = 10; // 党委评分总分
const MAX_UPLOAD_FILE_SIZE = 10; // 文件上传最大大小（M）
const MAX_IMPORT_TASK_TEMPLATE_SIZE = 20; // 个性指标导入模板上传最大大小（M）
const ROOT_ACCOUNT = 100; // root账号权限，系统管理
const ORGANIZATION_ACCOUNT = 101; // 组织部汇总账号权限
const DEPT_NORMAL = 108; // 科员级账号
const DEPT_MINISTER = 107; // 科长级账号
const DEPT_LEADER = 106; // 副局长、分管领导
const BUREAU_MINISTER = 103; // 局长
const BUREAU_MANAGE = 102; // 局级管理
const PARTY_GROUP = 104; // 党组成员
const ASSESS_MINITOR = 105; // 绩效监督小组
const FILE_SPACE_BASE_DIR = "http://123.249.36.222:8082"; // 文件床服务访问地址

const numberQQ = "12345678"; // 联系QQ
const numberPhone = "12345678"; // 联系电话
const company = "XXXX公司"; // 所属单位


export {
  months,
  seasons,
  tableColumns,
  tableColumns2,
  normItems,
  roleItems,
  normItemsAll,
  departmentList,
  regionList,
  normTypesV1,
  normTypesV2,
  SPECIAL_SCORE,
  MAX_UPLOAD_FILE_SIZE,
  MAX_IMPORT_TASK_TEMPLATE_SIZE,
  ROOT_ACCOUNT,
  ORGANIZATION_ACCOUNT,
  FILE_SPACE_BASE_DIR,
  DEPT_NORMAL,
  DEPT_MINISTER,
  DEPT_LEADER,
  BUREAU_MINISTER,
  BUREAU_MANAGE,
  PARTY_GROUP,
  ASSESS_MINITOR,
  numberQQ,
  numberPhone,
  company
}